import React from 'react';
import MyDataProgressSteps from './MyDataProgressSteps';

export default function MyDataConnectLayout({ step, onBack, children }) {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '24px 16px' }}>
      <MyDataProgressSteps current={step} />
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 4,
            padding: '7px 14px', borderRadius: 20,
            border: '1px solid #d1d5db', background: '#fff',
            color: '#4b5563', fontSize: 13, fontWeight: 500,
            cursor: 'pointer', marginBottom: 8,
          }}
        >
          ← 이전
        </button>
      )}
      {children}
    </div>
  );
}
